import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";
import InputBase from "@material-ui/core/InputBase";
import { TypeAppliedTheme } from "@src/Stores/Themes/types";
import SearchIcon from "@material-ui/icons/Search";

export const STSearchWrapper = styled.div`
  position: relative;
  border-radius: ${theme.shape.borderRadius}px;  
  background-color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor + "26"};  

  :hover {
    background-color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor + "26"};
  }

  margin-right: ${theme.spacing(2)}px;
  margin-left: 0;
  width: 100%;

  ${theme.breakpoints.up("sm")} {
    margin-left: ${theme.spacing(3)}px;
    width: auto;
  }
`;

export const STSearchIcon = styled(SearchIcon)`
  color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor} !important;
`;

export const STIconWrapper = styled.div`
  width: ${theme.spacing(9)}px;
  height: 100%;
  z-index: 99999;
  position: absolute;
  /* pointer-events: none; */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const STInputBase = styled(InputBase).attrs({
  classes: {
    root: "root",
    input: "input",
  },
})`
  && {
    color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor};
    .root {
      width: 100%;
    }

    .input {
      padding-top: ${theme.spacing(1)}px;
      padding-right: ${theme.spacing(1)}px;
      padding-bottom: ${theme.spacing(1)}px;
      padding-left: ${theme.spacing(10)}px;
      transition: ${theme.transitions.create("width")};
      width: 100%;

      ${theme.breakpoints.up("md")} {
        width: 200px;
      }
    }
  }
`;
